export const isSmallScreen = () => {
  let getWidth = window.screen.width;
  return getWidth <= 768 ? true : false
}